import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
  Tooltip
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";
import PropTypes from "prop-types";
import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import { Add } from "@material-ui/icons";
import MuiAlert from "@material-ui/lab/Alert";
import { InputLabel } from "components/BulkUpload";
import LoaderView from "components/LoaderView";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getActivityGroups, getJobFamilies } from "redux/actions/appActions";
import { saveBulkEntries } from "services/contractorTimesheet";
import { getWorkerPunchRecords } from "services";
import DropDowns from "./DropDowns";
import PunchRows from "./PunchRows";
import { deepEqual, getTotals, getErrorMessage, recordFormat } from "./utils";
import { getValidationSchema } from "./validators";
import { ALL_ACTIVITIES, MANAGE_TIMESHEET } from "navigation/CONSTANTS";
import { useHistory, useLocation } from "react-router-dom";
import { jobTypeITContractor } from "utils";
import { useRemoteConfig } from "providers";
import { convertStringToArray } from "utils/rcUtils";
import { DELETED_STATUS, dateConfig } from "config";
const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: theme.spacing(3),
    width: 'min-content',
    maxWidth: '95%'
  },
  stickHeader: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "white",
  },
  stickFooter: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "white",
  },
  headerRow: {
    backgroundColor: theme.palette.primary.main,
  },
  footerRow: {
    backgroundColor: theme.palette.primary.main,
  },
  pageTitle: {
    color: theme.palette.primary.main,
    fontWeight: 400,
    paddingRight: 5
  },
  back: {}
}));

const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
].map((e) => e.toUpperCase());

export default function ContractorTimesheetPage(props) {
  const location = useLocation();
  const locationProps = location.state;

  const history = useHistory();
  const classes = useStyles();
  const jobProjects = useRemoteConfig("contractorProjects");
  const jobProjectOptions = jobProjects ? convertStringToArray(jobProjects) : [];
  const initialRecord = [];
  const initialTotals = Array.from(Array(7)).map(() => ({ hours: 0 }));
  const initialTotalsObj = {};
  for (let i = 0; i < initialTotals.length; ++i) {
    initialTotalsObj[`day${i + 1}`] = initialTotals[i];
  }
  const initialActivityTotal = {}
  const {
    register,
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    errors,
    trigger,
    setError,
    clearErrors,
    formState,
    watch
  } = useForm({
    defaultValues: { records: initialRecord, weekTotal: initialTotalsObj, activityTotal: initialActivityTotal },
    resolver: yupResolver(getValidationSchema()),
    //mode: "onChange",
  });

  useEffect(() => {
    if (locationProps && locationProps.worker) {
      setValue("selectedWorker", locationProps.worker);
    } else if (!user || !user.workerId) {
      history.push('/');
    }
  }, [locationProps]);

  // const formReset = reset();
  const { isValid, isSubmitting, isDirty } = formState;

  console.log("isValid", isValid, isSubmitting);

  const { user, isAuthenticated } = useSelector((state) => state.user.auth);

  const { t } = useTranslation();

  const [oldData, setOldData] = useState(null);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "records",
  });
  const records = useWatch({ control, name: "records" });
  console.log("watchRecords", records);
  const [loading, setLoading] = useState(true);
  const [saveAllowed, setSaveAllowed] = useState(false);
  const [dataModified, setDataModifed] = useState(false);
  const [selectedFieldDropdowns, setSelectedFieldDropdowns] = useState([]);
  const [open, setOpen] = useState(false);
  const [totalHours, setTotalHours] = useState(0);
  const [workerSchedule, setWorkerShedule] = useState({});
  const [popupDetails, setPopupDetails] = useState({ type: 'success', message: t("other.timeSheetSuccessMsg") });

  const translatedDays = days
    .map((item) => {
      switch (item) {
        case "SUNDAY":
          return (item = t("other.dscLblSunday"));
        case "MONDAY":
          return (item = t("other.dscLblMonday"));
        case "TUESDAY":
          return (item = t("other.dscLblTuesday"));
        case "WEDNESDAY":
          return (item = t("other.dscLblWednesday"));
        case "THURSDAY":
          return (item = t("other.dscLblThursday"));
        case "FRIDAY":
          return (item = t("other.dscLblFriday"));
        case "SATURDAY":
          return (item = t("other.dscLblSaturday"));
        default:
          item = "new";
      }
    })
    .map((e) => e.toUpperCase());

  useEffect(() => {
    if (oldData) {
      const { records: oldRecords } = oldData;
      if (oldRecords && records) {
        const recordsModified = deepEqual(oldRecords, records);
        setDataModifed(!recordsModified);
      }
    }
  }, [oldData, records])

  const gotoReview = () => {
    //As per the calendar UI features, this older one has to be retained, so on click of cancel it should navigate to Manage Timesheets view
    // history.push(ALL_ACTIVITIES, { isAllPunchView: true });
    //history.push(MANAGE_TIMESHEET, { isTimesheetView: true });
    history.goBack();
  };

  const handleSelectionChange = (selections) => {
    setSelectedFieldDropdowns(selections);
  };

  const handleDropdownCancel = () => {
    //reset();
  };

  const dispatch = useDispatch();

  const handleAdd = (record = {}) => {
    append(record);
    trigger();
  };

  const handleDelete = (index) => {
    console.log("delete clicked", index)
    if (index >= 0) {
      remove(index);
      setTimeout(()=>{
        onPunchRowUpdate(0, -1);
      },1);
    }
  };

  const handleAddProject = (record) => {
    if (record && record.details) {
      const isRepeated = fields.filter(field => field.details === record.details).length > 0 ? true : false;
      if (isRepeated) {
        setPopupDetails({
          type: 'warning',
          message: "Project is already added!"
        })
        setOpen(true);
      } else {
        handleAdd({ ...record });
      }
    }
  };

  const handleSubmitAction = async (data) => {
    const actionTS = new Date().toISOString();
    const originalRecords = oldData?.records || [];
    const currentProjects = (data?.records || []).map(r => r?.details || "");
    const updatedRecords = [...(data?.records || [])];

    // Add missing original records
    originalRecords.forEach(record => {
      if (!currentProjects.includes(record.details)) {
        updatedRecords.push({
          ...recordFormat,
          details: record.details
        });
      }
    });
    data.updatedRecords = updatedRecords;
    let dataToSubmit = {
      ...data,
      weekStartDate: selectedFieldDropdowns.weekStart,
      weekEndDate: selectedFieldDropdowns.weekEnd,
      actionBy: isAuthenticated && user && user.workerId ? user.workerId : selectedFieldDropdowns.selectedWorker.workerId,
      actionTS: actionTS,
      selectedWorker: selectedFieldDropdowns.selectedWorker,
      customerSite: data.customerSite || "",
      workerSchedule,
      savePunchesToTimesheet: isAuthenticated && user && user.workerId ? user.workerId !== selectedFieldDropdowns.selectedWorker.workerId : false
    };
    console.log("Data to Submit", dataToSubmit, isAuthenticated, oldData);
    if (dataToSubmit.selectedWorker && dataToSubmit.selectedWorker.workerId && dataToSubmit.weekEndDate && dataToSubmit.weekStartDate) {
      setLoading(true);
      const weekEnd = moment(dataToSubmit.weekEndDate).endOf("week").add(1, 'day').format(dateConfig.format6);
      // Fetch the selected week punches to update
      let punchesData = await getWorkerPunchRecords(dataToSubmit.selectedWorker.workerId, dataToSubmit.weekStartDate, weekEnd).then((data) => {
        const weekDayObject = { punchesToBeDeleted: {}, deletedPunches: [] };
        data && data.forEach(punch => {
          const date = new Date(punch.inLocalTS);
          const dayOfWeekIndex = date.getDay(); // 0 = Sunday, 1 = Monday, ...
          if (!weekDayObject[`day${dayOfWeekIndex + 1}`]) {
            weekDayObject[`day${dayOfWeekIndex + 1}`] = {};
          }
          if (punch.jobType && punch.jobType == jobTypeITContractor && punch.jobProjectInfo) {
            if (!weekDayObject[`day${dayOfWeekIndex + 1}`][punch.jobProjectInfo]) {
              weekDayObject[`day${dayOfWeekIndex + 1}`][punch.jobProjectInfo] = { ...punch };
            } else {
              let deletePunch = { ...punch };
              weekDayObject['punchesToBeDeleted'][deletePunch.id] = { ...punch };
              deletePunch.status = DELETED_STATUS;
              deletePunch.version = deletePunch.version ? deletePunch.version + '1' : deletePunch.version;
              weekDayObject['deletedPunches'].push(deletePunch)
            }
          } else {
            let deletePunch = { ...punch };
            weekDayObject['punchesToBeDeleted'][deletePunch.id] = { ...punch };
            deletePunch.status = DELETED_STATUS;
            deletePunch.version = deletePunch.version ? deletePunch.version + '1' : deletePunch.version;
            weekDayObject['deletedPunches'].push(deletePunch)
          }
        });
        return weekDayObject;
      }).catch(err => {
        console.log("error in fetching selected week punches data", err);
        return null;
      });
      console.log("Data punch", punchesData);
      if (punchesData == null) {
        return;
      }
      //setLoading(false); 
      saveBulkEntries(dataToSubmit, punchesData)
        .then(() => {
          let { actionBy, actionTS, savePunchesToTimesheet, workerSchedule, ...rest } = dataToSubmit;
          setPopupDetails({
            type: 'success',
            message: t("other.timeSheetSuccessMsg")
          })
          setOpen(true);
          setOldData(rest);
          setSaveAllowed(false);
          setLoading(false);
        })
        .catch((e) => {
          setPopupDetails({
            type: 'error',
            message: e.message
          })
          setOpen(true);
          setLoading(false);
          console.error(e);
        });
    } else {
      setPopupDetails({
        type: 'warning',
        message: "Please fill missing details"
      })
      setOpen(true);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    // dispatch(getActivityGroups());
    // dispatch(getJobFamilies());
    setOldData({ records: initialRecord, weekTotal: initialTotalsObj, activityTotal: initialActivityTotal });
  }, []);

  const checkAllValid = (totalHours, selectedFieldDropdowns) => {
    let allowed = false;
    if (totalHours > 0.0) allowed = true;
    if (selectedFieldDropdowns) {
      if (!selectedFieldDropdowns.weekStart) allowed = false;
      if (!selectedFieldDropdowns.weekEnd) allowed = false;
    } else allowed = false;
    return allowed;
  };

  const onPunchRowUpdate = (row, dayIdx) => {
    clearErrors();
    const records = getValues().records || [];
    const cTotals = getTotals(records);
    const { totals, activityTotal, totalHours, errors: allErrors } = cTotals;
    console.log("onPunchRowUpdate", records, cTotals)
    register('activityTotal');
    setValue("activityTotal", activityTotal);
    setValue("weekTotal", totals);
    setValue("totalHours", totalHours);
    setTotalHours(cTotals.totalHours);
    let valid1 = true;
    if (oldData) {
      valid1 = !deepEqual(oldData.records, records);
    }
    let valid2 = checkAllValid(
      cTotals.totalHours,
      selectedFieldDropdowns
    );
    setSaveAllowed(valid1 && valid2);
     allErrors && Object.entries(allErrors).forEach(([field, value]) => {
        setError(field, value);
      });
      trigger();
  }

  return (
    <div className={classes.root}>
      <Snackbar
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
      >
        <Alert severity={popupDetails.type ? popupDetails.type : 'info'} onClose={handleClose}>
          {popupDetails.message ? popupDetails.message : ""}
        </Alert>
      </Snackbar>
      <LoaderView loading={loading}>
        <Grid container direction="row">
          <Grid item>
            <IconButton aria-label="back" className={classes.back} onClick={gotoReview}>
              <ArrowBackSharpIcon fontSize="medium" />
            </IconButton>
          </Grid>
          <Grid item style={{ display: 'flex', alignItems: 'end' }}>
            <Typography variant="h6" gutterBottom className={classes.pageTitle}>
              {"Contractor Timesheet"}
            </Typography>
          </Grid>
        </Grid>
        <form noValidate onSubmit={handleSubmit(handleSubmitAction)}>
          <DropDowns
            {...{
              control,
              register,
              reset,
              setValue,
              getValues,
              trigger,
              errors,
              setError,
              clearErrors,
              disabled: false,
              locationProps,
            }}
            initialRecord={initialRecord}
            initialTotalsObj={initialTotals}
            setOldData={setOldData}
            onChangeSelections={handleSelectionChange}
            onDropdownCancel={handleDropdownCancel}
            setWorkerShedule={setWorkerShedule}
            loading={loading}
            setLoading={setLoading}
            handleAdd={handleAdd}
            jobProjectOptions={jobProjectOptions}
            handleAddProject={handleAddProject}
            fields={fields}
            onUpdate={() => {
              const values = getValues();
              console.log("getValues", values);
              const records = values.records;
              const cTotals = getTotals(records);
              const { totals, activityTotal, totalHours } = cTotals;
              setValue("weekTotal", totals);
              register('activityTotal');
              setValue("activityTotal", activityTotal);
              setTotalHours(cTotals.totalHours);
              setValue("totalHours", totalHours);
              let valid2 = true;
              if (oldData) {
                valid2 = !deepEqual(oldData, values);
              }
              let valid3 = cTotals.totalHours > 0;
              console.log("valid2,3", valid2, valid3, oldData)
              setSaveAllowed(valid2 && valid3);
            }}
            onPunchRowUpdate={onPunchRowUpdate}
          />

          <TableContainer component={Paper}>
            <Table aria-label="punches table" size="small" padding="default">
              <TableHead>
                <TableRow className={classes.headerRow}>
                  <TableCell align="left">
                    <Typography
                      className={classes.stickHeader}
                      variant="body1"
                      component="h6"
                    >
                      &nbsp;&nbsp;{t("other.lblProjectDetails")}
                    </Typography>
                  </TableCell>
                  {translatedDays.map((day, dayIndex) => (
                    <TableCell align="center" key={`col_${dayIndex}`}>
                      <Typography
                        className={classes.stickHeader}
                        variant="body1"
                        component="h6"
                      >
                        {day}
                      </Typography>
                    </TableCell>
                  ))}
                  <TableCell align="left">
                    <Typography
                      className={classes.stickHeader}
                      variant="body1"
                      component="h6"
                    >
                      &nbsp;{t("other.timeSheetTotals")}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography
                      className={classes.stickHeader}
                      variant="body1"
                      component="h6"
                      style={{
                        width: 200
                      }}
                    >
                      &nbsp;{t("other.comments")}
                    </Typography>
                  </TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <PunchRows
                  {...{
                    control,
                    register,
                    reset,
                    setValue,
                    getValues,
                    trigger,
                    errors,
                    setError,
                    clearErrors,
                    disabled: false,
                    dropdowns: selectedFieldDropdowns,
                  }}
                  onDelete={handleDelete}
                  onUpdate={onPunchRowUpdate}
                  fields={fields}
                  watch={watch}
                />
              </TableBody>
              <TableFooter>
                {/* <TableRow>
                  <TableCell colSpan={10}>
                    <Button onClick={()=>handleAdd()} color="secondary">
                      <Add /> {t("other.timeSheetAdd")}
                    </Button>
                  </TableCell>
                </TableRow> */}
                <TableRow className={classes.footerRow}>
                  <TableCell align="left" colSpan={1}>
                    <Typography
                      className={classes.stickFooter}
                      variant="body1"
                      component="h6"
                    >
                      {t("other.timeSheetTotals")}
                    </Typography>
                  </TableCell>
                  {days.map((day, dayIndex) => (
                    <TableCell align="center" key={`total_${dayIndex}`}>
                      <Tooltip
                        arrow
                        title={getErrorMessage(errors.weekTotal, `day${dayIndex + 1}`, 'hours')}
                        open={getErrorMessage(errors.weekTotal, `day${dayIndex + 1}`, 'hours')}
                      >
                        <InputLabel
                          fullWidth
                          readOnly
                          margin="dense"
                          inputRef={register()}
                          name={`weekTotal.day${dayIndex + 1}.hours`}
                          defaultValue={"0"}
                          inputProps={{
                            style: { color: "white" },
                          }}
                        />
                      </Tooltip>
                    </TableCell>
                  ))}
                  <TableCell align="left">
                    <InputLabel
                      fullWidth
                      readOnly
                      margin="dense"
                      inputRef={register()}
                      name={`totalHours`}
                      defaultValue={"0"}
                      inputProps={{
                        style: { color: "white" },
                      }}
                    />
                  </TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          <Grid container justify="space-between" style={{ marginTop: 24 }}>
            <Grid item>
              <Button
                onClick={() => {
                  reset();
                  register('selectedWorker');
                  setValue('selectedWorker', selectedFieldDropdowns?.selectedWorker)
                  console.log("clear clicked", getValues());
                  setSaveAllowed(false);
                }}
                color="secondary"
                disabled={!isDirty || isSubmitting}
              >
                {t("other.timeSheetClear")}
              </Button>
            </Grid>
            <Grid item>
              <Grid container justify="space-between" spacing={2}>
                <Grid item>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={gotoReview}
                  >
                    {t("general.cancelBtn")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={!isValid || isSubmitting || !dataModified}
                  >
                    {t("other.timeSheetSave")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </LoaderView>
    </div>
  );
}
ContractorTimesheetPage.propTypes = {
  worker: PropTypes.object,
};
